import React from "react";

import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetterAllWorlds } from "../../../../../../../util/capitalizeFirstLetter";
import { DespatchContainerStatus } from "../../../../../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      alignItems: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      padding: "8px 12px",
      height: "32px",
      borderRadius: "100px",
      whiteSpace: "nowrap",
      width: "fit-content",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Manrope",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const DespatchContainerBadgeStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const { t: translate } = useTranslation();

  const renderBadge = (
    backgroundColor: string,
    textColor: string,
    value?: string,
    formatWord = true
  ) => {
    if (value) {
      const formatted = formatWord ? capitalizeFirstLetterAllWorlds(value) : value;

      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={formatted}
          className={className}
        />
      );
    }

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case DespatchContainerStatus.AVAILABLE.toLowerCase():
      return renderBadge("#ECFDF3", "#039855", translate("available"), false);
    case DespatchContainerStatus.ALL_DESPATCHED.toLowerCase():
      return renderBadge("#FEF3F2", "#D92D20", translate("allDespatched"), false);
    default:
      return renderBadge("#F4F3FF", "#6938EF", value);
  }
};

export default DespatchContainerBadgeStatus;
